module.exports = __webpack_public_path__ + "img/floradix.e8db7552.jpeg";